module.exports = __webpack_public_path__ + "img/category_menu.e61eb21c.png";